import React from "react";
import {IconDocumentLinesCircle} from "../../../../../../components/buttons/IconButtons";
import CustomUserChip from "../../../../../../components/CustomUserChip";
import {POSITION_MODEL} from "../../../../../../Helpers/PositionModel";
import CratesAndPalletsTransportSection from "./CratesAndPalletsTransportSection";
import ExpectedQuantitiesSection from "./ExpectedQuantitiesSection";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * @description
 * Renders the sections of a crates and pallets return that the requester
 * captures before the vehicle reaches the gate: the transport that returns the
 * crates and the quantities that are expected with it. What is left blank is
 * completed by the guard when the vehicle arrives.
 *
 * @param {Function} t - Translation function.
 * @param {Function} handleChange - Change handler of the form.
 * @param {Object} materialRequest - Current form information.
 * @param {boolean} emptyFields - Indicates whether the required fields must be highlighted.
 */
const CratesAndPalletsReturnSections = ({
    t,
    handleChange,
    materialRequest,
    emptyFields
}) => {

    return (
        <div className='col-12 py-3 mt-3 border-radius-8px background-secondary-50 border-dashed-secondary-150'>
            <CustomUserChip
                className='mt-0 p-0 chip-secondary-150-100 justify-content-start d-flex w-100'
                name={t('any_field_you_leave_blank_will_be_completed_by_the_guard_at_the_gate')}
                Icon={IconDocumentLinesCircle}
                showAvatar={true}
                classNameIcon={'icon-color-secondary-700'}
                variant='large'
                iconPosition={POSITION_MODEL.LEFT}
            />

            <CratesAndPalletsTransportSection
                t={t}
                materialRequest={materialRequest}
                handleChange={handleChange}
                emptyFields={emptyFields}
            />

            <ExpectedQuantitiesSection
                t={t}
                materialRequest={materialRequest}
                handleChange={handleChange}
                emptyFields={emptyFields}
                required={false}
            />
        </div>
    );
};

export default CratesAndPalletsReturnSections;
